import { UserPermissionEnum } from "@/types/user"
import { TFunction } from "i18next"

export const getTreeData = (t: TFunction<"translation", undefined>) => {
  return [
    {
      title: t("layout.isAdmin"),
      key: UserPermissionEnum.ADMIN,
      children: [
        {
          title: t("layout.orgMana"),
          key: "org-manager",
          children: [
            {
              title: t("layout.orgInfoUpdate"),
              key: UserPermissionEnum.ACT_ORG_EDIT,
            },
            {
              title: t("layout.orgMemberUpdate"),
              key: UserPermissionEnum.ACT_ORG_EDIT_MEM,
            },
          ],
        },
      ],
    },
  ]
}
